/**
 * `YYYY-MM-DD` → the weekday, in Portuguese — lifted from `ProfilePage.tsx`
 * unchanged. See the original for why the date is read at UTC midnight: it is
 * already cut in the learner's own zone by the query that produced it, so a
 * local re-interpretation would rename the mark on the strip.
 */
function weekdayAt(date: string): Date {
  const [year, month, day] = date.split('-').map(Number);
  return new Date(Date.UTC(year ?? 1970, (month ?? 1) - 1, day ?? 1));
}

const WEEKDAY_NARROW = new Intl.DateTimeFormat('pt-BR', { weekday: 'narrow', timeZone: 'UTC' });
const WEEKDAY_LONG = new Intl.DateTimeFormat('pt-BR', { weekday: 'long', timeZone: 'UTC' });

export function weekdayInitial(date: string): string {
  return WEEKDAY_NARROW.format(weekdayAt(date)).toLocaleUpperCase('pt-BR');
}

export function weekdayName(date: string): string {
  return WEEKDAY_LONG.format(weekdayAt(date));
}
